import { useEffect, useRef, useState } from 'react';
import 'intersection-observer';

export default ({ root = null, rootMargin, threshold = 0, callback }) => {
    const [entry, updateEntry] = useState({});
    const [node, setNode] = useState(null);

    const observer = useRef(
        new IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio > 0) callback();
                updateEntry(entry);
            },
            {
                root,
                rootMargin,
                threshold,
            },
        ),
    );

    useEffect(
        () => {
            const { current: currentObserver } = observer;

            currentObserver.disconnect();

            if (node) currentObserver.observe(node);

            return () => currentObserver.disconnect();
        },
        [node],
    );

    return [setNode, entry];
};
